export const API_UNITS_LIST = '/instrument/units/';

export const API_INSTRUMENTS = '/instrument/instruments/';

export const API = {
  USERS: {
    LIST: '/users/',
    REGISTER: '/users/register/',
  },

  INSTRUMENT: {
    VIEW: '/instrument/instruments/',
    DELETE: '/instrument/instruments/delete_multiple/',
    OVERVIEW: '/instrument/instruments/overview/',

    REFERENCES: {
      VIEW: '/instrument/certified-references/',
      RAW: '/instrument/references/',
      MANUFACTURERS: '/instrument/references/manufacturers/',
      DELETE: '/instrument/certified-references/delete_multiple/',
    },

    // ------------------------------------------------------
    UNITS: '/instrument/units/',
    STATUS_COUNT: '/instrument/instruments/status_count',
    DEVICES: {
      LIST: '/instrument/devices/',
      MANUFACTURERS: '/instrument/devices/manufacturers/',
      DELETE: '/instrument/devices/delete_multiple/',
    },
    TRANSMITTERS: '/instrument/transmitters/',
    INDICATORS: '/instrument/indicators/',
    SWITCHES: '/instrument/switches/',
    LIST: '/instrument/list/',
    CALIBRATIONS: '/instrument/calibrations/',
    SET_POINT_RESULTS: '/instrument/setpoints/',
    REFERENCE_CHECKS: '/instrument/checks/',
  },
  CLIENTS: {
    VIEW: '/clients/clients/',

    LOCATIONS: {
      NON_RECURSIVE: '/clients/locations/non-recursive/',
      RECURSIVE: '/clients/locations/recursive/',
      // PATHS: '/clients/locations/paths/instrument/',
      PATHS: {
        INSTRUMENT: '/clients/locations/paths/instrument/',
        LOCATION: '/clients/locations/paths/location/',
      },
    },

    // ------------------------------------------------------
    LIST: '/clients/',
    SITES: {
      VIEW: '/clients/sites/',
    },
  },
};
